import { Component, OnInit } from '@angular/core';
import { AIImageUploadService } from 'src/app/services/ai-image-upload.service';
import { AuthService } from 'src/app/services/auth.service';

import {
  catchError,
  from,
  forkJoin,
  Observable,
  switchMap,
  throwError,
} from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ai-image-upload',
  templateUrl: './ai-image-upload.component.html',
  styleUrls: ['./ai-image-upload.component.scss'],
})
export class AiImageUploadComponent implements OnInit {
  selectedFiles: File[] = [];
  uploadProgress: { fileName: string; progress: number }[] = [];
  uploading = false;
  private sasToken: string = '';
  private folderName : string = '';
  constructor(
    private azureBlobService: AIImageUploadService,
    private toastr: ToastrService,
    private authService: AuthService
  ) {}
  ngOnInit(): void {
    this.getSasToken();
  }

  onFolderSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFiles = Array.from(input.files);
      this.uploadProgress = this.selectedFiles.map((file) => ({
        fileName: file.name,
        progress: 0,
      }));
    }
  }

  uploadFiles(): void {
    if (this.selectedFiles.length === 0) return;

    this.uploading = true;
    const batchSize = 10;
    const batches: File[][] = [];
    for (let i = 0; i < this.selectedFiles.length; i += batchSize) {
      batches.push(this.selectedFiles.slice(i, i + batchSize));
    }
    this.processBatches(batches, 0);
  }
  private getSasToken() {
    this.authService.getSas().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.sasToken = responseData.data;
          this.folderName = 'CaimsUpload'+Date.now().toString();
         } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private processBatches(batches: File[][], index: number): void {
    if (index >= batches.length) {
      this.uploading = false;
      return;
    }

    const batch = batches[index];
    const uploadObservables: Observable<void>[] = batch.map((file, i) => {
      const fileIndex = index * 10 + i;
      return this.azureBlobService.uploadFile(
        file,
        this.sasToken,
        this.folderName,
        (progress) => {
          this.uploadProgress[fileIndex].progress = Math.round(progress * 100);
        }
      );
    });

    forkJoin(uploadObservables).subscribe({
      next: () => {
        this.processBatches(batches, index + 1);
      },
      error: (err) => {
        console.error('Batch upload failed:', err);
        this.uploading = false;
      },
    });
  }
}
